import { context_has_buyer, context_has_performable } from '~lib/context';
import { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';

export function mcm_is_crossroads(order: McmOrderContext, name: 'basic' | 'bronze' | 'silver' | 'gold' | 'platinum') {
  if (!context_has_buyer(order, 'crossroads')) {
    return false;
  }

  const droneVideo = context_has_performable(order, 'drone', { type: McmDroneType.VIDEO_PHOTO });
  const dronePhoto = context_has_performable(order, 'drone', { type: McmDroneType.PHOTO });
  const video = context_has_performable(order, 'video');
  const zillow = context_has_performable(order, 'zillow');
  const photo = context_has_performable(order, 'photo');

  if (photo && zillow && droneVideo && video) {
    return name === 'platinum';
  }

  if (photo && zillow && droneVideo) {
    return name === 'gold';
  }

  if (photo && zillow && dronePhoto) {
    return name === 'silver';
  }

  if (photo && zillow) {
    return name === 'bronze';
  }

  if (photo) {
    return name === 'basic';
  }

  return false;
}
